import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormGenerator from '../FormGenerator';

class Step1 extends PureComponent {
  static propTypes = {
    season: PropTypes.object.isRequired,
    sections: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string,
    optionByField: PropTypes.object.isRequired,
    applicants: PropTypes.number.isRequired,
    tabIndex: PropTypes.number.isRequired,
    setTabIndex: PropTypes.func.isRequired,
  };

  static defaultProps = {
    hexColorCodeC: '#efb900',
  };

  renderContent = () => {
    const { hexColorCodeC, sections, optionByField } = this.props;
    const content = [];
    const hasSections = !!Object.keys(sections).length;
    for (let i = 0; i < this.props.applicants; i++) {
      content.push(
        <div
          key={i}
          className={classnames('ui bottom attached tab segment accented', {
            active: this.props.tabIndex === i,
          })}
        >
          {hasSections && (
            <FormGenerator
              form={`member${i + 1}`}
              sections={sections}
              sectionsToRender={['Name & Contact Information', 'Address']}
              hexColorCodeC={hexColorCodeC}
              optionByField={optionByField}
              season={this.props.season}
              ageConsent
            />
          )}
        </div>
      );
    }
    return content;
  };

  renderTabSections() {
    if (this.props.applicants) {
      const numOfApps = this.props.applicants;
      if (numOfApps >= 2) {
        const tabs = [];
        for (let i = 0; i < numOfApps; i++) {
          tabs.push(
            <div
              key={i}
              className={classnames('item', {
                active: this.props.tabIndex === i,
              })}
              onClick={() => this.props.setTabIndex(i)}
            >
              Member {i + 1}
            </div>
          );
        }

        return (
          <div
            style={{ borderColor: `#${this.props.hexColorCodeC}` }}
            className="ui top attached tabular menu accented"
          >
            {tabs}
            <div
              className={classnames('item', {
                active: this.props.tabIndex === numOfApps,
              })}
              onClick={() => this.props.setTabIndex(numOfApps)}
            >
              Team
            </div>
          </div>
        );
      }
    }

    return '';
  }

  render() {
    const { hexColorCodeC, sections, optionByField } = this.props;
    const hasSections = !!Object.keys(sections).length;
    return (
      <div>
        {this.renderTabSections()}
        {this.renderContent()}
        <div
          className={classnames('ui bottom attached tab segment accented', {
            active: this.props.tabIndex === this.props.applicants,
          })}
        >
          {hasSections && (
            <FormGenerator
              form="team"
              sections={sections}
              sectionsToRender={['Team']}
              hexColorCodeC={hexColorCodeC}
              optionByField={optionByField}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Step1;



// WEBPACK FOOTER //
// ./src/components/apply/Step1.js